const fonts = {
  sans: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`,
  serif: `"Instrument Serif", "Iowan Old Style", Georgia, "Times New Roman", serif`,
  mono: `"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace`,
};

const colors = {
  bg: "#FAF9F5",
  bgAlt: "#F4F2EC",
  surface: "#FFFFFF",
  surfaceHover: "#F6F4EE",
  border: "#E8E5DE",
  borderStrong: "#D7D3C9",
  text: "#1F1E1D",
  textMuted: "#6B6864",
  textSubtle: "#8E8B86",
  accent: "#C96442",
  accentHover: "#B0563A",
  accentSoft: "#F7E9E1",
  success: "#15803D",
  successSoft: "#DCFCE7",
  danger: "#B91C1C",
  dangerSoft: "#FEE2E2",
  warning: "#A16207",
  warningSoft: "#FEF3C7",
  info: "#1D4ED8",
  infoSoft: "#DBEAFE",
};

const radius = {
  sm: "6px",
  md: "10px",
  lg: "14px",
  xl: "20px",
  pill: "999px",
};

const shadow = {
  xs: "0 1px 2px rgba(31,30,29,0.04)",
  sm: "0 2px 6px rgba(31,30,29,0.06)",
  md: "0 6px 18px rgba(31,30,29,0.08)",
  lg: "0 18px 40px rgba(31,30,29,0.12)",
  focus: `0 0 0 3px rgba(201,100,66,0.20)`,
};

const space = (n) => `${n * 4}px`;

const breakpoints = {
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
};

const media = {
  sm: `@media (max-width: ${breakpoints.sm})`,
  md: `@media (max-width: ${breakpoints.md})`,
  lg: `@media (max-width: ${breakpoints.lg})`,
};

const theme = { fonts, colors, radius, shadow, space, breakpoints, media };

export default theme;
